export default function counterInit() {
    const elements = document.querySelectorAll("[data-sa-counter]");

    if (!elements.length) return;

    // Check if element is scrolled into view
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const element = entry.target;

                // Prevent re-triggering
                if (element.dataset.animated) return;

                // Trigger counter for elements scrolled into view
                animateCounter(element);

                // Stop observing once animated
                observer.unobserve(element);
            });
        },
        {
            threshold: 0.2, // Trigger when 20% visible
        },
    );

    elements.forEach((el) => observer.observe(el));

    // Animate numbers for specific element
    function animateCounter(element) {
        element.dataset.animated = true;

        const data = {
            startAt: parseFloat(element.dataset.saStart),
            endAt: parseFloat(element.dataset.saEnd),
            delay: parseInt(element.dataset.saDelay) || 0,
            interval: parseInt(element.dataset.saInterval) || 1,
            format: "{}",
            speed: parseInt(element.dataset.saSpeed) || 1000,
        };

        if (element.hasAttribute("data-sa-format")) {
            data.format = element.dataset.saFormat;
        } else if (element.textContent.trim() !== "") {
            data.format = element.textContent;
        }

        if (isNaN(data.startAt) || isNaN(data.endAt)) {
            throw new Error("data-sa-start and data-sa-end attributes are required and must be numbers");
        }

        let counter = data.startAt;

        element.textContent = data.format.replace("{}", counter);

        const totalDifference = Math.abs(data.endAt - data.startAt);
        const steps = totalDifference / Math.abs(data.interval);
        const intervalSpeed = data.speed / steps;

        setTimeout(() => {
            const interval = setInterval(() => {
                counter += data.interval;

                if ((data.endAt > data.startAt && counter > data.endAt) || (data.endAt < data.startAt && counter < data.endAt)) {
                    counter = data.endAt;
                }

                const formatted = counter >= 1000 ? numberWithCommas(counter) : counter;

                element.textContent = data.format.replace("{}", formatted);

                if (counter === data.endAt) {
                    clearInterval(interval);
                }
            }, intervalSpeed);
        }, data.delay);
    }

    // Add commas for numbers greater than 1000
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
